import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { BaseSiteService } from '@spartacus/core';
import { jsPDF } from 'jspdf';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { MakeAPaymentService } from 'src/app/make-a-payment/make-a-payment.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { OpenStatementsService } from '../open-statements.service';

@Component({
  selector: 'app-statement-display',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './statement-display.component.html',
  styleUrls: ['./statement-display.component.scss'],
  host: {
    '[style.overflow]': '"hidden"',
    '[style.width]': '"100%"',
  },
  standalone: false
})
export class StatementDisplayComponent implements OnInit, OnDestroy {
  @ViewChild('content') content: ElementRef;
  @ViewChild('scrollableContent') scrollBody: ElementRef;
  @Input() toShow: boolean;
  @Input() statement: any;
  someInputField: any;
  allStatementData: any;
  accountNumber = null;
  loadSub: Subscription;
  userAccSubs: Subscription;
  allStatementsSub: Subscription;
  showPopUp: boolean;
  isPDF = false;
  baseSiteId: string;
  isAsmUser: boolean = false;
  firewallExempt: boolean = false;
  isComServeAgent: boolean = false;
  csAgentAuthSubscription: Subscription;
  constructor(
    private readonly stService: OpenStatementsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly makeAPayment: MakeAPaymentService,
    private readonly sharedService: SharedService,
    public activeModal?: NgbActiveModal,
    private baseSite?: BaseSiteService,
    private readonly csAgentAuthService?: CsAgentAuthService,
    private readonly pfService?: CustomProfileAndPreferencesService,
  ) { }

  ngOnInit(): void {
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });

    this.baseSite.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.showPopUp = false;
    this.allStatementData = [];
    this.cdr.detectChanges();
    this.stService.getAccountId();

    this.pfService._userAccountData.subscribe((res) => {
      if (this.accountNumber == null) {
        this.accountNumber = res.defaultB2BUnit.uid;
        this.getAllStatements();
      }
    });

    this.loadSub = this.stService.loadStatements.subscribe((res) => {
      if (!!res !== false) {
        this.getAllStatements();
      }
    });
  }

  checkNegativeValue(data, checkNegative = false) {
    return checkNegative ? Number(data) < 0 : data?.transType === 'Credit Memo';
  }

  generateSavePdf() {
    this.isPDF = true;
    this.activeModal.close();
    const element = (document.getElementsByClassName('acc-order-details')[0]) as HTMLElement;
    let doc = new jsPDF('p', 'pt', 'letter');
    doc.html(element, {
      callback: (jsPdf) => {
        jsPdf.save("Statement.pdf");
        this.stService.reloadComponent.next(true);
      },
      margin: [20, 20, 20, 20], // Set appropriate margins
      autoPaging: 'text', // Crucial for handling text flow across pages
      html2canvas: {
        allowTaint: true,
        letterRendering: true,
        logging: false,
        scale: 0.5, // Adjust the scale to fit content
      },
    });
  }

  generateInvoicePDF(invoiceNo) {
    this.makeAPayment.downloadPdf(invoiceNo);
  }

  onPrint() {
    window.print(); // only modal content should get print
  }

  getAllStatements() {
    this.allStatementsSub = this.stService
      .getAllStatements({
        accountId: this.accountNumber,
        endDate: this.statement.toDte,
        fields: 'DEFAULT',
      })
      .subscribe((res) => {
        if (res) {
          if (res?.isComServeAgent) {
            this.isComServeAgent = res.isComServeAgent;
          }
          this.allStatementData = JSON.parse(JSON.stringify(res));
          this.showPopUp = true;
          this.cdr.detectChanges();
          if (this.toShow === false) {
            this.generateSavePdf();
          }
        }
      });
  }

  ngOnDestroy() {
    this.showPopUp = false;
    this.loadSub?.unsubscribe();
    this.userAccSubs?.unsubscribe();
    this.allStatementsSub?.unsubscribe();
  }
  getScheduledPaymentDate(date) {
    const x = new Date(date);
    x.setDate(x.getDate() - 3);
    return x.toLocaleDateString(undefined, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }
  calcTotalDiscounts(statements, column) {
    let total = 0;

    statements?.forEach(entry => {
      total += column === 'discount' ? parseFloat(entry.discount) :
        (entry.transType.toLowerCase() === 'credit memo' ? (0 - entry.amountDue) : entry.amountDue);
    });

    return total;
  }

  asmStringCheck(invoiceNumber) {
    let val = (/^\d+$/).test(invoiceNumber);
    return (!val || invoiceNumber?.length >= 11 || invoiceNumber?.length <= 7 ||
      (!invoiceNumber?.startsWith('47') && !invoiceNumber?.startsWith('84')) ||
      (this.isAsmUser && this.isComServeAgent));
  }
}